"use client";
import { Box, List } from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";

type BenefitOption = {
  title: string;
  subTitle?: string;
  options: { label: string; text: string }[];
};

const BenefitsComp = (props: BenefitOption) => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { title, subTitle, options } = props;
  return (
    <Box mt={-8}>
      <Heading variant={HeadingVariant} mb={4}>
        {title}
      </Heading>
      {subTitle && (
        <Text variant={TextVariant} color="text.100" mb={4}>
          {subTitle}
        </Text>
      )}
      <List.Root gap={2}>
        {options.map((option, index) => (
          <List.Item key={index}>
            <Text as="span" variant={TextVariant} fontWeight={600}>
              {option.label} : {""}
            </Text>
            <Text as="span" variant={TextVariant} color="text.100">
              {option.text}
            </Text>
          </List.Item>
        ))}
      </List.Root>
    </Box>
  );
};

export default BenefitsComp;
